// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: s7tPuSdh1nP
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import LoginInput from "../../LoginInput"; // plasmic-import: aQnFozGxZ1/component
import LoginPasswordInput from "../../LoginPasswordInput"; // plasmic-import: tgUi1FC4vi/component
import CustomErrorComponent from "../../CustomErrorComponent"; // plasmic-import: 42T9zhO9Sy/component
import Checkbox2 from "../../Checkbox2"; // plasmic-import: 3oEpY7J1Ez8/component
import SignupButton from "../../SignupButton"; // plasmic-import: chd7tlXqLt/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicSignupPage.module.css"; // plasmic-import: s7tPuSdh1nP/css
import vectorsZlhptEmGP from "./images/vectors.svg"; // plasmic-import: ZlhptEmG_P/picture

createPlasmicElementProxy;

export const PlasmicSignupPage__VariantProps = new Array();

export const PlasmicSignupPage__ArgProps = new Array();

const $$ = {};

function PlasmicSignupPage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "checkAgree.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"signupScreen"}
            data-plasmic-override={overrides.signupScreen}
            className={classNames(projectcss.all, sty.signupScreen)}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"frame1"}
              data-plasmic-override={overrides.frame1}
              hasGap={true}
              className={classNames(projectcss.all, sty.frame1)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__zQa6B
                )}
              >
                {"Create your Astrius account "}
              </div>
              <div
                data-plasmic-name={"username"}
                data-plasmic-override={overrides.username}
                className={classNames(projectcss.all, sty.username)}
              >
                <div
                  data-plasmic-name={"rectangle"}
                  data-plasmic-override={overrides.rectangle}
                  className={classNames(projectcss.all, sty.rectangle)}
                >
                  <LoginInput
                    data-plasmic-name={"signupEmailInput"}
                    data-plasmic-override={overrides.signupEmailInput}
                    className={classNames(
                      "__wab_instance",
                      sty.signupEmailInput
                    )}
                  />
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__dkE4
                  )}
                >
                  {"Email"}
                </div>
              </div>
              <div
                data-plasmic-name={"invalidEmailText"}
                data-plasmic-override={overrides.invalidEmailText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.invalidEmailText
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Invalid email address"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Invalid email address"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"username3"}
                data-plasmic-override={overrides.username3}
                className={classNames(projectcss.all, sty.username3)}
              >
                <div
                  data-plasmic-name={"rectangle4"}
                  data-plasmic-override={overrides.rectangle4}
                  className={classNames(projectcss.all, sty.rectangle4)}
                >
                  <LoginPasswordInput
                    data-plasmic-name={"signupPasswordInput"}
                    data-plasmic-override={overrides.signupPasswordInput}
                    className={classNames(
                      "__wab_instance",
                      sty.signupPasswordInput
                    )}
                  />
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__rkfHc
                  )}
                >
                  {"Password"}
                </div>
              </div>
              <div
                data-plasmic-name={"username4"}
                data-plasmic-override={overrides.username4}
                className={classNames(projectcss.all, sty.username4)}
              >
                <div
                  data-plasmic-name={"rectangle5"}
                  data-plasmic-override={overrides.rectangle5}
                  className={classNames(projectcss.all, sty.rectangle5)}
                >
                  <LoginPasswordInput
                    data-plasmic-name={"signupConfirmPasswordInput"}
                    data-plasmic-override={overrides.signupConfirmPasswordInput}
                    className={classNames(
                      "__wab_instance",
                      sty.signupConfirmPasswordInput
                    )}
                  />
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ibWEs
                  )}
                >
                  {"Confirm Password"}
                </div>
              </div>
              <div
                data-plasmic-name={"incorrectPasswordsText"}
                data-plasmic-override={overrides.incorrectPasswordsText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.incorrectPasswordsText
                )}
              >
                <React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ color: "#FF0000" }}
                  >
                    {"Passwords do not match"}
                  </span>
                </React.Fragment>
              </div>
              <CustomErrorComponent
                data-plasmic-name={"customErrorInstance"}
                data-plasmic-override={overrides.customErrorInstance}
                className={classNames(
                  "__wab_instance",
                  sty.customErrorInstance
                )}
                customErrorText={
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___6MyOk
                    )}
                  >
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Failed to login"}
                      </span>
                    </React.Fragment>
                  </div>
                }
              />

              <div
                data-plasmic-name={"freeBox"}
                data-plasmic-override={overrides.freeBox}
                className={classNames(projectcss.all, sty.freeBox)}
              >
                <Checkbox2
                  data-plasmic-name={"checkAgree"}
                  data-plasmic-override={overrides.checkAgree}
                  className={classNames("__wab_instance", sty.checkAgree)}
                  isChecked={
                    p.generateStateValueProp($state, [
                      "checkAgree",
                      "isChecked"
                    ]) ?? false
                  }
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "checkAgree",
                      "isChecked"
                    ])(eventArgs[0]);
                  }}
                />

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___43ADe
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>
                      {"By checking this box you agree to "}
                    </React.Fragment>
                    {
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__ynXmk
                        )}
                        href={"https://astrius.co/"}
                        target={"_blank"}
                      >
                        {"Our Terms of Service"}
                      </a>
                    }

                    <React.Fragment>{" and "}</React.Fragment>
                    {
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__kt9Kw
                        )}
                        href={"https://astrius.co/"}
                        target={"_blank"}
                      >
                        {"Privacy Policy"}
                      </a>
                    }

                    <React.Fragment>
                      {", as well as our partner "}
                    </React.Fragment>
                    {
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link___1QeyM
                        )}
                        href={
                          "https://www.dwolla.com/legal/dwolla-account-terms-of-service/"
                        }
                        target={"_blank"}
                      >
                        {"Dwolla's Terms of Service"}
                      </a>
                    }

                    <React.Fragment>{" and "}</React.Fragment>
                    {
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__mOd0
                        )}
                        href={"https://www.dwolla.com/legal/privacy/"}
                        target={"_blank"}
                      >
                        {"Privacy Policy"}
                      </a>
                    }

                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
              </div>
              <SignupButton
                data-plasmic-name={"signupButton"}
                data-plasmic-override={overrides.signupButton}
                className={classNames("__wab_instance", sty.signupButton)}
              />
            </p.Stack>
            <p.PlasmicImg
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              alt={""}
              className={classNames(sty.img)}
              displayHeight={"auto"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"auto"}
              loading={"lazy"}
              src={{
                src: vectorsZlhptEmGP,
                fullWidth: 1280,
                fullHeight: 111,
                aspectRatio: 11.531532
              }}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "signupScreen",
    "frame1",
    "username",
    "rectangle",
    "signupEmailInput",
    "invalidEmailText",
    "username3",
    "rectangle4",
    "signupPasswordInput",
    "username4",
    "rectangle5",
    "signupConfirmPasswordInput",
    "incorrectPasswordsText",
    "customErrorInstance",
    "freeBox",
    "checkAgree",
    "signupButton",
    "img"
  ],

  signupScreen: [
    "signupScreen",
    "frame1",
    "username",
    "rectangle",
    "signupEmailInput",
    "invalidEmailText",
    "username3",
    "rectangle4",
    "signupPasswordInput",
    "username4",
    "rectangle5",
    "signupConfirmPasswordInput",
    "incorrectPasswordsText",
    "customErrorInstance",
    "freeBox",
    "checkAgree",
    "signupButton",
    "img"
  ],

  frame1: [
    "frame1",
    "username",
    "rectangle",
    "signupEmailInput",
    "invalidEmailText",
    "username3",
    "rectangle4",
    "signupPasswordInput",
    "username4",
    "rectangle5",
    "signupConfirmPasswordInput",
    "incorrectPasswordsText",
    "customErrorInstance",
    "freeBox",
    "checkAgree",
    "signupButton"
  ],

  username: ["username", "rectangle", "signupEmailInput"],
  rectangle: ["rectangle", "signupEmailInput"],
  signupEmailInput: ["signupEmailInput"],
  invalidEmailText: ["invalidEmailText"],
  username3: ["username3", "rectangle4", "signupPasswordInput"],
  rectangle4: ["rectangle4", "signupPasswordInput"],
  signupPasswordInput: ["signupPasswordInput"],
  username4: ["username4", "rectangle5", "signupConfirmPasswordInput"],
  rectangle5: ["rectangle5", "signupConfirmPasswordInput"],
  signupConfirmPasswordInput: ["signupConfirmPasswordInput"],
  incorrectPasswordsText: ["incorrectPasswordsText"],
  customErrorInstance: ["customErrorInstance"],
  freeBox: ["freeBox", "checkAgree"],
  checkAgree: ["checkAgree"],
  signupButton: ["signupButton"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSignupPage__ArgProps,
          internalVariantPropNames: PlasmicSignupPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSignupPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSignupPage";
  } else {
    func.displayName = `PlasmicSignupPage.${nodeName}`;
  }
  return func;
}

export const PlasmicSignupPage = Object.assign(
  // Top-level PlasmicSignupPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    signupScreen: makeNodeComponent("signupScreen"),
    frame1: makeNodeComponent("frame1"),
    username: makeNodeComponent("username"),
    rectangle: makeNodeComponent("rectangle"),
    signupEmailInput: makeNodeComponent("signupEmailInput"),
    invalidEmailText: makeNodeComponent("invalidEmailText"),
    username3: makeNodeComponent("username3"),
    rectangle4: makeNodeComponent("rectangle4"),
    signupPasswordInput: makeNodeComponent("signupPasswordInput"),
    username4: makeNodeComponent("username4"),
    rectangle5: makeNodeComponent("rectangle5"),
    signupConfirmPasswordInput: makeNodeComponent("signupConfirmPasswordInput"),
    incorrectPasswordsText: makeNodeComponent("incorrectPasswordsText"),
    customErrorInstance: makeNodeComponent("customErrorInstance"),
    freeBox: makeNodeComponent("freeBox"),
    checkAgree: makeNodeComponent("checkAgree"),
    signupButton: makeNodeComponent("signupButton"),
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicSignupPage
    internalVariantProps: PlasmicSignupPage__VariantProps,
    internalArgProps: PlasmicSignupPage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicSignupPage;
/* prettier-ignore-end */
